module.exports = __webpack_public_path__ + "img/list.e86c83c6.png";